<template>
  <div class="gs-aff-panel">
    <header class="gs-aff-panel__head">
      <div>
        <h3>Affiliate permissions</h3>
        <p>Control which customer details affiliates can see or export, and which bonus tools they can attach to their sales.</p>
      </div>
    </header>

    <section class="gs-aff-section">
      <div class="gs-aff-section__head">
        <div>
          <strong>{{ $t('frontend_product_step9_affiliate_data_sharing') }}</strong>
          <p>Applies to customers an affiliate referred. Everything is off by default.</p>
        </div>
      </div>
      <table class="gs-aff-matrix">
        <thead>
          <tr>
            <th scope="col">Customer detail</th>
            <th scope="col" class="is-toggle">{{ $t('frontend_view') }}</th>
            <th scope="col" class="is-toggle">{{ $t('frontend_export') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="field in dataFields" :key="field.key">
            <td>
              <strong>{{ field.label }}</strong>
              <span>{{ field.description }}</span>
            </td>
            <td class="is-toggle">
              <button
                type="button"
                role="switch"
                class="gs-aff-switch"
                :aria-checked="sharingOptions[field.key].view ? 'true' : 'false'"
                :aria-label="`Allow affiliates to view ${field.noun}`"
                @click="sharingOptions[field.key].view = !sharingOptions[field.key].view"
              ></button>
            </td>
            <td class="is-toggle">
              <button
                type="button"
                role="switch"
                class="gs-aff-switch"
                :aria-checked="sharingOptions[field.key].export ? 'true' : 'false'"
                :aria-label="`Allow affiliates to export ${field.noun}`"
                @click="sharingOptions[field.key].export = !sharingOptions[field.key].export"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="gs-aff-section">
      <div class="gs-aff-section__head">
        <div>
          <strong>{{ $t('frontend_product_step9_affiliate_integrations') }}</strong>
          <p>Let affiliates deliver their own bonuses and track conversions for the sales they refer.</p>
        </div>
      </div>
      <div class="gs-aff-settings">
        <div v-for="setting in bonusSettings" :key="setting.key" class="gs-aff-setting">
          <div>
            <strong>{{ setting.label }}</strong>
            <p>{{ setting.description }}</p>
          </div>
          <button
            type="button"
            role="switch"
            class="gs-aff-switch"
            :aria-checked="shareDetails[setting.key] ? 'true' : 'false'"
            :aria-label="setting.label"
            @click="shareDetails[setting.key] = !shareDetails[setting.key]"
          ></button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  watch: {
    model: {
      handler() {
        this.$emit('update-model', this.localModel);
      },
      deep: true
    }
  },
  data() {
    return {
      localModel: this.model,
    };
  },
  computed: {
    shareDetails() {
      return this.localModel.affiliate_data_share_details;
    },
    sharingOptions() {
      return this.shareDetails.data_sharing_options;
    },
    dataFields() {
      return [
        { key: 'email', label: this.$t('frontend_email'), noun: 'customer email addresses', description: 'Customer email address' },
        { key: 'phone', label: this.$t('frontend_phone'), noun: 'customer phone numbers', description: 'Customer phone number' },
        { key: 'address', label: this.$t('frontend_address'), noun: 'customer addresses', description: 'Billing and shipping address' },
      ];
    },
    bonusSettings() {
      return [
        {
          key: 'affiliate_can_drop_pixel',
          label: this.$t('frontend_product_step9_Affiliate_Can_Drop_Pixel'),
          description: 'Affiliates can add their own tracking code to measure the sales they refer.',
        },
        {
          key: 'affiliate_integration',
          label: this.$t('frontend_product_step9_Affiliate_integration'),
          description: 'Affiliates can add buyers they referred to their own email lists or tools.',
        },
        {
          key: 'affiliate_bonus_webhook',
          label: this.$t('frontend_product_step9_Affiliate_webhook'),
          description: 'Affiliates can send each sale they referred to their own webhook URL.',
        },
        {
          key: 'affiliate_bonus_membership',
          label: this.$t('frontend_product_step9_Affiliate_membership'),
          description: 'Affiliates can grant buyers access to a bonus membership.',
        },
        {
          key: 'affiliate_bonus_file',
          label: this.$t('frontend_product_step9_Affiliate_file'),
          description: 'Affiliates can deliver bonus files to buyers they referred.',
        },
      ];
    },
  },
};
</script>
